module.exports = __webpack_public_path__ + "media/images/services/vo-dbcf40a2f21e9bd622a04a4bf38eab09.svg";